import React, { useRef } from "react";

import { Icon } from "../Icon";

import { ButtonStyle } from "./styles";
import { ButtonColor, ButtonSize, ButtonVariant } from "./types";

export type ButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "color"> & {
  isLoading?: boolean;
  variant?: ButtonVariant;
  color?: ButtonColor;
  size?: ButtonSize;
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "primary",
      color = "primary",
      size = "medium",
      type = "button",
      isLoading,
      children,
      onClick,
      ...props
    },
    ref
  ) => {
    // A ref, not a state: a second click queued before the next render must already see the lock.
    const isClickPendingRef = useRef(false);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      if (isLoading || isClickPendingRef.current) return;
      const result: unknown = onClick?.(event);
      if (result instanceof Promise) {
        isClickPendingRef.current = true;
        const release = () => {
          isClickPendingRef.current = false;
        };
        result.then(release, release);
      }
    };

    return (
      <ButtonStyle
        ref={ref}
        variant={variant}
        color={color}
        size={size}
        type={type}
        onClick={handleClick}
        {...props}
      >
        {isLoading ? (
          <>
            <ButtonStyle.RotatingContainer>
              <Icon name="progressActivity" />
            </ButtonStyle.RotatingContainer>
            Chargement...
          </>
        ) : (
          children
        )}
      </ButtonStyle>
    );
  }
);
